// editors/markdoc/utils/decorationHelper.js
import { Decoration, WidgetType } from "@codemirror/view";
import { syntaxTree } from "@codemirror/language";

/////////////////////////////////////////////////////////////////////////////////
// Exported Helper Functions
/////////////////////////////////////////////////////////////////////////////////


export function shouldHideMarkers(view, node, mode) {
  if (!view || !view.state || !node || typeof mode !== 'string') {
    return false; // Default to not hiding markers if inputs are invalid
  }

  // Hide markers if mode is "show" or if mode is "edit" and cursor is not on the same line
  return mode === "show" || (mode === "edit" && !isCursorOnSameLine(view, node));
}

export const hiddenDecoration = (from, to) =>
  Decoration.replace({}).range(from, to);

export function isCursorOnSameLine(view, node) {
  const [cursor] = view.state.selection.ranges;
  const doc = view.state.doc;
  const cursorLine = doc.lineAt(cursor.from).number;
  const nodeLine = doc.lineAt(node.from).number;
  return cursorLine === nodeLine;
}

export function findMarkerPositions(tree, from, to, markTypeName) {
  let markStart = null;
  let markEnd = null;
  let foundPair = false;

  tree.iterate({
    from,
    to,
    enter: (nodeRef) => {
      if (nodeRef.type.name === markTypeName) {
        if (!markStart) {
          markStart = { from: nodeRef.from, to: nodeRef.to };
        } else {
          markEnd = { from: nodeRef.from, to: nodeRef.to };
          foundPair = true;
        }
      }
    },
  });

  return { markStart, markEnd, foundPair };
}

export function decorateHiddenMarkers(widgets, markStart, markEnd) {
  let decorations = [];

  if (markStart && typeof markStart.from === 'number' && typeof markStart.to === 'number') {
    const decoration = hiddenDecoration(markStart.from, markStart.to);
    decorations.push(decoration);
    widgets.push(decoration);
  }

  if (markEnd && typeof markEnd.from === 'number' && typeof markEnd.to === 'number') {
    const decoration = hiddenDecoration(markEnd.from, markEnd.to);
    decorations.push(decoration);
    widgets.push(decoration);
  }

  return Decoration.set(decorations);
}

export function decorateFallback(widgets, node, contentClass) {

  return widgets.push(
    Decoration.mark({ class: `cm-markdoc-${contentClass}` }).range(
      node.from,
      node.to
    )
  );
}
